const ReduceItemData = {
  data() {
    return {
      l10n: {},
    }
  },
  methods: {
    transformTranslationData(l10n) {
      this.l10n = l10n.reduce(function (result, element) {
        result[element.lang] = element
        return result
      }, {})
    },
  },
}

export default ReduceItemData
